export default {
  DASHBOARD: 'D',
  LISTING_PAGE: 'L',
  POST_LISTING_PAGE: 'P',
  SEARCH_PAGE: 'S',
  WATCHLIST: 'W',
  MESSAGES: 'M',
  PORTALS: 'R'
}
